<div class="container">
  <div class="header">
    <h1 mat-dialog-title style="margin-bottom: 20px" [innerHTML]="data.Title"></h1>
  </div>
  <div mat-dialog-content [innerHTML]="data.Content" style="margin-bottom: 10px">
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>{{ 'OK' | translate}}</button>
  </div>
</div>
